import { render, staticRenderFns } from "./OwnedEarnedCollectedUsers.vue?vue&type=template&id=f5498672&scoped=true&"
import script from "./OwnedEarnedCollectedUsers.vue?vue&type=script&lang=js&"
export * from "./OwnedEarnedCollectedUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5498672",
  null
  
)

export default component.exports